import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

const enhance = compose(injectIntl);

const TimeRange = React.memo(
  ({
    from,
    to,
    longFormat,
    onlyDate,
    fullTime,
    intl,
    className = '',
    collapseSameMinute = true,
  }) => {
    const dateFormats = intl.messages.date_formats;

    const today = moment();
    const tomorrow = moment().add(1, 'days');
    const _from = moment(from);
    const _to = moment(to);

    if (longFormat) {
      return (
        <div className={className}>
          {_from.format(dateFormats.day_number_month)}
          &nbsp;
          {_to.isAfter(_from, 'minute')
            ? _from.format(dateFormats.time) + ' - ' + _to.format(dateFormats.time)
            : _to.format(dateFormats.time)}
        </div>
      );
    }

    if (onlyDate) {
      return (
        <div className={className}>
          {_from.isSame(today, 'day')
            ? _from.format(dateFormats.today_day_month)
            : _from.isSame(tomorrow, 'day')
            ? _from.format(dateFormats.tomorrow_day_month)
            : _from.format(dateFormats.day_number_month)}
        </div>
      );
    }

    if (fullTime) {
      return (
        <div className={className}>
          {_from.format(dateFormats.time) + ' - ' + _to.format(dateFormats.time)}
        </div>
      );
    }

    return (
      <div className={className}>
        {collapseSameMinute && !_to.isAfter(_from, 'minute')
          ? _to.format(dateFormats.time)
          : _from.format(dateFormats.time) + ' - ' + _to.format(dateFormats.time)}
      </div>
    );
  }
);

TimeRange.propTypes = {
  from: PropTypes.string,
  to: PropTypes.string,
  longFormat: PropTypes.bool,
  onlyDate: PropTypes.bool,
  fullTime: PropTypes.bool,
  intl: PropTypes.any,
  className: PropTypes.string,
  collapseSameMinute: PropTypes.bool,
};

export default enhance(TimeRange);
